import en from './en.json'

const messagesByLocale: Record<string, typeof en> = {
  en
}

export const defaultLocale = 'en'

export const messages = messagesByLocale[navigator.language] || messagesByLocale.en
